import { Injectable } from "@angular/core";

import { environment } from "../../../environments/environment";


@Injectable({ providedIn: 'root' })
export class WebSocketService {
    appUrl: string = environment.appBaseUrl;
    private socket: WebSocket | null = null;

    connect() {
        if (!this.socket) {
            this.socket = new WebSocket(`wss://${this.appUrl.replaceAll('https://', '').replaceAll('http://', '')}`);
        }
    }

    disconnect() {
        if (this.socket) {
            this.socket.close();
            this.socket = null;
        }
    }

    isConnected() {
        return !!this.socket;
    }
}